var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.25073C0.586188 5.25073 0.250727 5.58619 0.250727 6C0.250727 6.41381 0.586188 6.74927 1 6.74927L1 5.25073ZM23.5298 6.52982C23.8224 6.23721 23.8224 5.7628 23.5298 5.47019L18.7615 0.701841C18.4689 0.409231 17.9944 0.409231 17.7018 0.70184C17.4092 0.99445 17.4092 1.46886 17.7018 1.76147L21.9404 6L17.7018 10.2385C17.4092 10.5311 17.4092 11.0056 17.7018 11.2982C17.9944 11.5908 18.4689 11.5908 18.7615 11.2982L23.5298 6.52982ZM1 6.74927L23 6.74928L23 5.25073L1 5.25073L1 6.74927Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.61ac815f4bea5b7a7ecae74c99ec9a16.svg";
export { ForwardRef as ReactComponent };